module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-4 p-sm-3"
  }, [_c('h2', {
    staticClass: "lead"
  }, [_vm._v("プロフィール管理")]), _vm._v(" "), _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-lg-6 col-sm-12 p-2 text-center"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('router-link', {
    staticClass: "btn d-block text-white lead py-5",
    attrs: {
      "to": "/profile/edit"
    }
  }, [_vm._v("プロフィール変更")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-sm-12 p-2 text-center"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('router-link', {
    staticClass: "btn d-block text-white lead py-5",
    attrs: {
      "to": "/profile/detail"
    }
  }, [_vm._v("プロフィール詳細")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-sm-12 p-2 text-center"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('router-link', {
    staticClass: "btn d-block text-white lead py-5",
    attrs: {
      "to": "/profile/edit-password"
    }
  }, [_vm._v("パスワード変更")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-sm-12 p-2 text-center"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('router-link', {
    staticClass: "btn d-block text-white lead py-5",
    attrs: {
      "to": "/profile/edit-email"
    }
  }, [_vm._v("メールアドレス変更")])], 1)])]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f0ddecd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/profile/Index.vue
// module id = 363
// module chunks = 1